import { render, staticRenderFns } from "./AboutNew.vue?vue&type=template&id=3a597575&scoped=true"
import script from "./AboutNew.vue?vue&type=script&lang=ts"
export * from "./AboutNew.vue?vue&type=script&lang=ts"
import style0 from "./AboutNew.vue?vue&type=style&index=0&id=3a597575&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a597575",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a597575')) {
      api.createRecord('3a597575', component.options)
    } else {
      api.reload('3a597575', component.options)
    }
    module.hot.accept("./AboutNew.vue?vue&type=template&id=3a597575&scoped=true", function () {
      api.rerender('3a597575', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/contractorDetails/AboutNew.vue"
export default component.exports